(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-back-link"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__shopifyArticleHistoryBackInit) return;
    window.__shopifyArticleHistoryBackInit = true;
    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-article-history-back]');
      if (!link) return;
      if (window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["data-deletion-body"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = Array.from(document.querySelectorAll('.dd-section[id]'));
    var tocLinks = document.querySelectorAll('.dd-toc__link');

    function updateActive() {
      var triggerLine = window.innerHeight * 0.25;
      var active = sections[0];

      for (var i = 0; i < sections.length; i++) {
        if (sections[i].getBoundingClientRect().top <= triggerLine) {
          active = sections[i];
        }
      }

      tocLinks.forEach(function (link) {
        link.classList.toggle('dd-toc__link--active', link.getAttribute('href') === '#' + active.id);
      });
    }

    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const pageParam = Number(url.searchParams.get('page') || 1);
  if (url.hash || pageParam > 1) {
    const scrollToTarget = () => {
      // A #card-id hash wins; otherwise a deep page link (?page=N) lands on
      // that page's first card — anchoring to the card (not the grid top)
      // stays correct when earlier pages prepend above it.
      let target = url.hash ? document.getElementById(url.hash.slice(1)) : null;
      if (!target && pageParam > 1) {
        target = document.querySelector(`.product-grid__item[data-page="${pageParam}"]`);
      }
      // The hash a card click leaves behind names the card's inner link
      // (product-card.js), not the grid item, and the `scroll-margin-top` that
      // keeps a landed card clear of the sticky filter chip lives on the item —
      // so scroll the item, or the card comes back tucked under the chip.
      target = target?.closest('.product-grid__item') ?? target;
      if (target) {
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    };
    document.addEventListener('DOMContentLoaded', scrollToTarget, { once: true });
    // Re-run once the banner's images/fonts have settled so we land accurately
    // at the products (e.g. arriving from the homepage hero via #products),
    // rather than mid-banner because the layout shifted after DOMContentLoaded.
    //
    // Only while the shopper has not scrolled themselves. `load` waits for
    // every image on a 20-card page and can fire seconds after the grid is
    // usable — back from a PDP (this store's pages are not eligible for the
    // back/forward cache, so every return is a full load) they had often
    // already scrolled on, and this second call yanked them back to the card.
    let scrolled = false;
    const markScrolled = () => (scrolled = true);
    for (const type of ['wheel', 'touchmove', 'keydown', 'pointerdown']) {
      window.addEventListener(type, markScrolled, { passive: true, once: true });
    }
    window.addEventListener(
      'load',
      () => {
        if (!scrolled) scrollToTarget();
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-details-grid"]) return;
  try {
    
  (function () {
    function initPdpKeyFeaturesToggles(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.pdp-key-features--collapsible:not([data-kf-bound])').forEach(function (wrap) {
        wrap.setAttribute('data-kf-bound', 'true');
        var btn = wrap.querySelector('.pdp-key-features__toggle');
        if (!btn) return;
        var more = btn.getAttribute('data-label-more') || 'Show more';
        var less = btn.getAttribute('data-label-less') || 'Show less';
        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          btn.textContent = collapsed ? more : less;
        });
      });
    }

    function onReady() {
      initPdpKeyFeaturesToggles(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initPdpKeyFeaturesToggles(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-how-it-compares"]) return;
  try {
    
  (function () {
    function initTakeawayToggles(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('[data-takeaway-wrap]:not([data-tw-bound])').forEach(function (wrap) {
        wrap.setAttribute('data-tw-bound', 'true');
        var btn = wrap.querySelector('.pdp-comparison__takeaway-toggle');
        var text = wrap.querySelector('.pdp-comparison__takeaway-text');
        if (!btn || !text) return;

        // Measure whether text overflows when unclamped
        var fullHeight = text.scrollHeight;
        wrap.classList.add('is-collapsed');
        var clampedHeight = text.getBoundingClientRect().height;
        wrap.classList.remove('is-collapsed');

        if (fullHeight <= clampedHeight + 2) {
          // Text fits within 3 lines — no toggle needed
          btn.style.display = 'none';
          return;
        }

        wrap.classList.add('is-collapsed');

        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          btn.textContent = collapsed
            ? (btn.getAttribute('data-label-more') || 'Read more')
            : (btn.getAttribute('data-label-less') || 'Show less');
        });
      });
    }

    function onReady() { initTakeawayToggles(document); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }
    document.addEventListener('shopify:section:load', function (e) { initTakeawayToggles(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-quick-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPdpKeyFeaturesToggles(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.pdp-key-features--collapsible:not([data-kf-bound])').forEach(function (wrap) {
        wrap.setAttribute('data-kf-bound', 'true');
        var btn = wrap.querySelector('.pdp-key-features__toggle');
        if (!btn) return;
        var more = btn.getAttribute('data-label-more') || 'Show more';
        var less = btn.getAttribute('data-label-less') || 'Show less';
        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          btn.textContent = collapsed ? more : less;
        });
      });
    }

    function setupQuickFeaturesGrid() {
      var quickFeatures = document.querySelector('.pdp-quick-features');
      var productMedia = document.querySelector('.product-information__media');

      if (quickFeatures && productMedia && window.matchMedia('(min-width: 750px)').matches) {
        var grid = productMedia.closest('.product-information__grid');

        if (grid) {
          var mediaColumn = document.createElement('div');
          mediaColumn.className = 'product-information__media-column';
          mediaColumn.style.display = 'flex';
          mediaColumn.style.flexDirection = 'column';
          mediaColumn.style.gap = '2rem';

          grid.insertBefore(mediaColumn, productMedia);
          mediaColumn.appendChild(productMedia);
          mediaColumn.appendChild(quickFeatures);
        }
      }
    }

    function onReady() {
      initPdpKeyFeaturesToggles(document);
      setupQuickFeaturesGrid();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initPdpKeyFeaturesToggles(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-body"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = Array.from(document.querySelectorAll('.priv-section[id]'));
    var tocLinks = document.querySelectorAll('.priv-toc__link');

    function updateActive() {
      var triggerLine = window.innerHeight * 0.25;
      var active = sections[0];

      for (var i = 0; i < sections.length; i++) {
        if (sections[i].getBoundingClientRect().top <= triggerLine) {
          active = sections[i];
        }
      }

      tocLinks.forEach(function (link) {
        link.classList.toggle('priv-toc__link--active', link.getAttribute('href') === '#' + active.id);
      });
    }

    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  })();

  } catch(e) { console.error(e); }
})();
})();
